import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Psearch(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Searching Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python searching tutorial for beginners.Searching in list python exampleCodeExampler provides Multiple Programming Examples for Beginners" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,python search,elasticsearch python,python search in string,python search string,python search list,python search in list,python search google,python search dictionary
,python search list for string,python search path,python search engine,python search and replace,python searching strings" />
<link rel="canonical" href="https://www.codeexampler.com/python-searching/"/>
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Searching in python List: </h1>

    <div className="first">
        <a href="/python-constructor">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    


<h2 className='headings'>Q-Python Searching strings in list Python Example?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">x</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-1">[</span>
                <span className="qwerty-2">2</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">5</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">1</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">10</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">30</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">45</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">56</span>
                <span className="qwerty-1">]</span>
            {"\n"}
                <span className="qwerty-6">if </span>
                <span className="qwerty-2">10 </span>
                <span className="qwerty-5">in </span>
                <span className="qwerty-5">x</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">    print</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-1">"</span>
                <span className="qwerty-10">Element is Present</span>
                <span className="qwerty-1">"</span>
                <span className="qwerty-1">)</span>
            {"\n"}
                <span className="qwerty-6">else </span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">    print</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-1">"</span>
                <span className="qwerty-10">Element is Not Present</span>
                <span className="qwerty-1">"</span>
                <span className="qwerty-1">)</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                           <span className="qwerty-8">Element is Present</span>
                           {"\n"}    
                           {"\n"}    
                 </code>
                   </pre>
                   </div>



<h2 className='headings'>Q-Searching Vowels in list Python Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">vowels</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">a</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">e</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">i</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">o</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">u</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">o</span>
                 <span className="qwerty-6">' </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-4">vowels</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">z</span>
                 <span className="qwerty-6">' </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-4">vowels</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                            <span className="qwerty-8">True</span>
                    {"\n"}
                            <span className="qwerty-8">False</span>
                            {"\n"}    
                            {"\n"}    
                  </code>
                    </pre>
                    </div>  






<h2 className='headings'>Q-Comparing b/w two lists Python Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-2">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">20</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">30</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">40</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-2">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">20</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">30</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">40</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty"> == </span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty"> is </span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                            <span className="qwerty-8">True</span>
                    {"\n"}
                            <span className="qwerty-8">False</span>
                            {"\n"}    
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 

<h2 className="mt-4 mh2">Python Finding the index:</h2>



<h2 className='headings'>Q-How Use index by using Vowels in Python search Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">vowels</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">a</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">e</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">i</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">o</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">u</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
             {"\n"}
                 <span className="qwerty-5"> # index of 'o'</span>
             {"\n"}
                 <span className="qwerty-7">index</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">vowels</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-7">index</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">o</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">The index of o:</span>
                 <span className="qwerty-6">' </span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">index</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                 <span className="qwerty-5"> # index of 'i'</span>
             {"\n"}
                 <span className="qwerty-7">index</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">vowels</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-7">index</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">i</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">The index of o:</span>
                 <span className="qwerty-6">' </span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">index</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                            <span className="qwerty-8">The index of o: </span>
                            <span className="qwerty-3">3</span>
                    {"\n"}
                            <span className="qwerty-8">The index of i: </span>
                            <span className="qwerty-3">2</span>
                            {"\n"}    
                            {"\n"}    
                  </code>
                    </pre>
                    </div>  


<h2 className="mt-4 mh2">Python Looping through a list:</h2>

<p className="mt-4 para"> please learn <span className="bold">range() function</span> firstly Python for loop and after you read this list looping</p>

<h2 className="mt-4 mh2">For Loop in Python Searching:</h2>



<h2 className='headings'>Q- How Use Python for Looping through a list and Search City Name?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-7">for </span>
                 <span className="qwerty-4">City </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">Mathura</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">Varanasi</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">Los Angeles</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">My City Name is</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">City</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                            <span className="qwerty-8">My City Name is </span>
                            <span className="qwerty-3">Mathura</span>
                    {"\n"}
                            <span className="qwerty-8">My City Name is </span>
                            <span className="qwerty-3">Varanasi</span>
                    {"\n"}
                            <span className="qwerty-8">My City Name is </span>
                            <span className="qwerty-3">Los Angeles</span>
                    
                            {"\n"}    
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 




<h2 className='headings'>Q-Creating a list using a range function Searching in list Python Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">list</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">2</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                            <span className="qwerty-1">[</span>
                            <span className="qwerty-8">1</span>
                            <span className="qwerty-1">,</span>
                            <span className="qwerty-8">2</span>
                            <span className="qwerty-1">,</span>
                            <span className="qwerty-8">3</span>
                            <span className="qwerty-1">,</span>
                            <span className="qwerty-8">4</span>
                            <span className="qwerty-1">,</span>
                            <span className="qwerty-8">5</span>
                            <span className="qwerty-1">]</span>
                    {"\n"} {"\n"}    
                  </code>
                    </pre>
                    </div>  



<h2 className='headings'>Q-Write a program to print all even elements of a list?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-2">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">15</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">20</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">25</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">30</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-7">for </span>
                 <span className="qwerty-2">i </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-6">    if </span>
                 <span className="qwerty-2">i</span>
                 <span className="qwerty">%</span>
                 <span className="qwerty-10">2</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-8">0</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">i</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                            <span className="qwerty-8">10</span>
                    {"\n"}
                            <span className="qwerty-8">20</span>
                    {"\n"}
                            <span className="qwerty-8">30</span>
                            {"\n"}    
                            {"\n"}    
                  </code>
                    </pre>
                    </div>

<p className="mt-4 para"><span className="bold">len()-</span> to count no items print (len(x))<br/>
1,<span className="bold">max()-</span>to print maxno(max(x))<br/>
2,<span className="bold">min()-</span>to print min no(min(x))<br/>
</p>

<h2 className="mt-4 mh2">Python Reverse:</h2>


<h2 className='headings'>Q-Write a program to print list in Python reverse?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">r</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">2</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">3</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">4</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">5</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-4">r</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-7">reverse</span>
                 <span className="qwerty-1">()</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">r</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                 <span className="qwerty-8">5</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">4</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">3</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">2</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">1</span>
                 <span className="qwerty-1">]</span>
                            {"\n"}    
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 

<h2 className="mt-4 mh2">Return Function in Python List:</h2>


<h2 className='headings'>Q-Find out common elements in two lists using a function?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-10">common</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">g</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">h</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-2">    output</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-7">    for </span>
                 <span className="qwerty-4">i </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-8">g</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-6">        if </span>
                 <span className="qwerty-4">i </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-8">h</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-2">            output</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-5">append</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">i</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty">    return </span>
                 <span className="qwerty-2">output</span>
             {"\n"}
             <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-8">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">6</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">4</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">8</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">10</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-8">2</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">4</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">8</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">9</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">15</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">common</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                            <span className="qwerty-1">[</span>
                            <span className="qwerty-8">4,</span>
                            <span className="qwerty-10">8</span>
                            <span className="qwerty-1">]</span>
                            {"\n"}    
                            {"\n"}    
                  </code>
                    </pre>
                    </div>   



<h2 className='headings'>Q-Write a program to count the no of Sublists in a list?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-10">check_sublist</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-3">x</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-4">    count</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-8">0</span>
             {"\n"}
                 <span className="qwerty-7">    for </span>
                 <span className="qwerty-4">i </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-3">x</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-6">        if </span>
                 <span className="qwerty-5">type</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">i</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-2">list</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-4">            count</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">count</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-8">1</span>
             {"\n"}
                 <span className="qwerty">    return </span>
                 <span className="qwerty-4">count</span>
             {"\n"}
             <span className="qwerty-3">x</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-8">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">2</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">3</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-8">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">20</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-8">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">3</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">5</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">check_sublist</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-3">x</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                            <span className="qwerty-8">2</span>
                            {"\n"}    
                            {"\n"}    
                  </code>
                    </pre>
                    </div>      



<h3 className="mt-4">Python search Convert list to String and Also Check <a target="blank" style={{ textDecoration: 'none' }} href="https://www.codeexampler.com/python-function">max function in python</a>:</h3>


<h2 className='headings'>Q-Write a program to count the no of sublists in a list?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">l</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">ram</span>
       
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">20</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-4">s</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-8">join</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">l</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">]</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">s</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">ram</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-3">20</span>
                 <span className="qwerty-1">]</span>
                            {"\n"}    
                            {"\n"}    
                  </code>
                    </pre>
                    </div>     




<h2 className='headings'>Q-Write a program to split the no of sublists in a list?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
      
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">India</span>
               
                 <span className="qwerty-1">,</span>
    
                 <span className="qwerty-10">USA</span>
   
                 <span className="qwerty-1">,</span>

                 <span className="qwerty-10">UK</span>
                 <span className="qwerty-6">'</span>
        
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-8">split</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-1">[</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">India</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">USA</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">UK</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">]</span>
                            {"\n"}    
                            {"\n"}    
                  </code>
                    </pre>
                    </div>  

  <h1 className="mt-5">  </h1>
       
  <div className="back">
        <a href="/python-constructor">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Psearch;